<template>
    <div v-if="article.article_languages[0] != null" class="listing-item-over">
        <figure>
            <img v-if="article.blob" :src="article.blob.url" alt=""/>
            <figcaption class="slide-overlay-animation">
                <h3><a :href="$store.state.hrefPrefix + '/category/' + article.category.slug">{{
                        article.category.category_languages[0].pivot.name
                    }}</a></h3>
                <h2><a :href="$store.state.hrefPrefix + '/articles/' + article.slug">{{
                        article.article_languages[0].pivot.title
                    }}</a></h2>
                <p v-if="article.second_author == null"><span>{{
                        $t('by')
                    }}</span>{{ article.author.author_languages[0].pivot.name }}</p>
                <p v-else><span>{{ $t('by') }}</span>{{ article.author.author_languages[0].pivot.name }} &
                    {{ article.second_author.author_languages[0].pivot.name }}</p>
            </figcaption>
        </figure>
    </div>
</template>

<script>
export default {
    name: "HomeFeaturedArticle",
    props: {
        article: {
            type: Object,
            default: null
        }
    }
}
</script>

<style scoped>

</style>
